import React from "react";
import { Controller } from "react-hook-form";
import { cn } from "../utils/utils";


// Memoized component
const TextArea = React.memo(
  ({ control, name, label, type, errors, placeholder, className }) => {
    return (
      <div className="flex flex-col">
        <Controller
          control={control}
          name={name}
          render={({ field: { value, onChange } }) => {
            return (
              <div className={cn("flex flex-col gap-2 text-neutral-90 ", className)}>
                <label htmlFor="" className="font-semibold text-[14px]  ">
                  {label}
                </label>
                <textarea
                  className="min-h-[52px] max-h-[82px] no-scrollbar px-3 pt-2  outline-none rounded-v-md  w-full border-[1px] border-neutral-30 placeholder:text-[12px] placeholder:font-semibold p-2 "
                  value={value}
                  type={type}
                  onChange={onChange}
                  onWheelCapture={(e) => {
                    e.target.blur();
                  }}
                  placeholder={placeholder}
                />
                {errors?.message && (
                  <span className="text-red-500 text-sm">
                    {errors?.message}
                  </span>
                )}
              </div>
            );
          }}
        />
      </div>
    );
  }
);

// Add a custom equality function to compare props if needed
const areEqual = (prevProps, nextProps) => {
  return (
    prevProps.control === nextProps.control &&
    prevProps.isPassword === nextProps.isPassword &&
    prevProps.setShowPassword === nextProps.setShowPassword &&
    prevProps.showPassword === nextProps.showPassword &&
    prevProps.name === nextProps.name &&
    prevProps.label === nextProps.label &&
    prevProps.type === nextProps.type &&
    prevProps.placeholder === nextProps.placeholder &&
    prevProps.className === nextProps.className &&
    prevProps.disabled === nextProps.disabled &&
    prevProps.tabIndex === nextProps.tabIndex &&
    prevProps.errors === nextProps.errors &&
    prevProps.required === nextProps.required
  );
};

export default React.memo(TextArea, areEqual);

